import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DocumentsService} from "../../../../../services/document.service";
import {UtilsService} from "../../../../../services/utils.service";
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common'; 

@Component({
  selector: 'app-cuestionario-cliente',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cuestionario-cliente.component.html',
  styleUrl: './cuestionario-cliente.component.css'
})
export class CuestionarioClienteComponent implements OnInit, OnChanges{
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  constructor(private documentService: DocumentsService,
              private utilsService: UtilsService) {
  }
  
  cuestionario: any = "";

  ngOnInit(): void {
    this.obtenerCuestionarioCliente()

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(' Desde cuestionario del cliente ')
  }

  print()
  {
    console.log("Se envia al cliente")
  }

  obtenerCuestionarioCliente(){
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'cuestionarioCliente').subscribe((res: any) => {
      this.cuestionario = res.content[0];
      console.log(this.cuestionario)

      }, err => {
        console.error(err)
      })
  }
}
